import ManageOrderList from "./manageOrderList";

export const ActiveFreeTrialPage   = () => <ManageOrderList defaultStatusFilter="trial" />;
export const PendingPaymentPage    = () => <ManageOrderList defaultStatusFilter="payment_pending" />;
export const ActivePaidPage        = () => <ManageOrderList defaultStatusFilter="paid_active" />;
export const ExpiringSoonPage      = () => <ManageOrderList defaultStatusFilter="expiring_soon" />;
export const PaidExpiredPage       = () => <ManageOrderList defaultStatusFilter="paid_expired" />;
export const FreeTrialExpiredPage  = () => <ManageOrderList defaultStatusFilter="free_trial_expired" />;
